import { matchPath } from 'react-router-dom';
import { paths } from '@/app/routes/paths';

const supportOperatorFacePaths = [
  paths.finance,
  paths.main,
  paths.profile,
  paths.shipmentDetails,
  paths.shipments
];

const supportOperatorFlowPaths = [
  paths.deliveryWarehouseCreate,
  paths.deliveryWarehouseDistribution,
  paths.deliveryWarehouseProducts,
  paths.profileEdit,
  paths.profileOrganizationEdit,
  paths.profileWarehouse,
  paths.profileWarehouseCreate,
  paths.profileWarehouses,
  paths.shipmentAttachments,
  paths.shipmentBudget,
  paths.shipmentBudgetServices,
  paths.shipmentCustomsClearance,
  paths.shipmentItemSku,
  paths.shipmentItems,
  paths.shipmentReception,
  paths.shipmentReceptionMedia,
  paths.shipmentReceptionResolution,
  paths.shipmentReceptionSku
];

const matchesPath = (pathname: string, path: string): boolean => {
  return Boolean(matchPath({ end: true, path }, pathname));
};

export const isSupportOperatorFaceRoute = (pathname: string): boolean => {
  return supportOperatorFacePaths.some((path) => matchesPath(pathname, path));
};

export const isSupportOperatorFlowRoute = (pathname: string): boolean => {
  return supportOperatorFlowPaths.some((path) => matchesPath(pathname, path));
};